import React from 'react'
import TextAreaField from '../../formFields/textAreaField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <TextAreaField {...fieldProps} />
))
